import { FC } from 'react';

const SandboxPage: FC = () => {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
};

export default SandboxPage;
